import { ExternalsList } from "../components/List/ExternalsList";
import { ExternalsCreate } from "../components/Create/ExternalsCreate";
import { ExternalsEdit } from "../components/Edit/ExternalsEdit";
import { ExternalsView } from "../components/View/ExternalsView";
import { BranchesOutlined } from "@ant-design/icons";
import { UserRole } from "@root/api.types";
export const EXTERNALS_LIST = {
    path: "/admin/externals",
    component: ExternalsList,
    roles: [UserRole.ADMIN, UserRole.ACCOUNTANT, UserRole.SHAREHOLDER],
    menu: {
        key: "EXTERNALS_LIST",
        label: "management.externals.menu.title",
        icon: BranchesOutlined,
    },
};
export const EXTERNALS_CREATE = {
    path: "/admin/externals/create",
    roles: [UserRole.ADMIN, UserRole.ACCOUNTANT, UserRole.SHAREHOLDER],
    component: ExternalsCreate,
};
export const EXTERNALS_EDIT = {
    path: "/admin/externals/:id/edit",
    roles: [UserRole.ADMIN, UserRole.ACCOUNTANT, UserRole.SHAREHOLDER],
    component: ExternalsEdit,
};
export const EXTERNALS_VIEW = {
    path: "/admin/externals/:id/view",
    roles: [UserRole.ADMIN, UserRole.ACCOUNTANT, UserRole.SHAREHOLDER],
    component: ExternalsView,
};
